module.exports = __webpack_public_path__ + "static/img/tc3.66deca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tc3.jpg
// module id = G7G6
// module chunks = 1